import React from 'react'
import {createColumnHelper, DisplayColumnDef, IdentifiedColumnDef} from '@tanstack/react-table'
import {LegionJob} from 'graphql-api'

import SelectAllRowsCell from './cell/SelectAllRows'
import SelectRowCell from './cell/SelectRow'
import JobIdCell from './cell/JobId'
import RaveUrlCell from './cell/RaveUrl'
import JobTypeCell from './cell/JobTypeCell'
import JobStatusCell from './cell/JobStatusCell'
import ActionsCell from './cell/Actions'

// @ts-ignore
import {DataGridColumns} from '@mdsol/onex-design'

const columnHelper = createColumnHelper<LegionJob>()
const columnsConfig: DataGridColumns[] = [
  columnHelper.accessor(
    row => `select-row-${row.jobId}`,
    {
      header: () => <SelectAllRowsCell />,
      id: 'selectJobRow',
      cell: props => <SelectRowCell {...props} />,
      className: 'select-job-row',
      style: {textAlign: 'center'},
      enableSorting: false,
      size: 44,
    } as DisplayColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    'jobId',
    {
      header: 'Job Id',
      textAlign: 'left',
      className: 'job-id-cell',
      cell: props => <JobIdCell {...props} />,
    } as IdentifiedColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    'hostname',
    {
      header: 'Url',
      textAlign: 'left',
      cell: props => <RaveUrlCell {...props} />,
    } as IdentifiedColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    'jobType',
    {
      header: 'Job Type',
      textAlign: 'left',
      cell: props => <JobTypeCell {...props} />,
    } as IdentifiedColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    'status',
    {
      header: 'Job Status',
      textAlign: 'left',
      cell: props => <JobStatusCell {...props} />,
      defaultFilter: true,
    } as IdentifiedColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    'createdTime',
    {
      header: 'Created Time',
      textAlign: 'left',
    } as IdentifiedColumnDef<LegionJob, any>
  ),
  columnHelper.accessor(
    row => `actions-${row.jobId}`,
    {
      header: 'Actions',
      enableSorting: false,
      className: 'actions-cell',
      cell: props => <ActionsCell {...props} />,
    } as DisplayColumnDef<LegionJob, any>
  ),
]

export default columnsConfig
